import React from 'react'
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
import AddConfig from './add'
import { component_tool } from '@/tool'
let { WizModal } = component_tool
const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })
const categoryConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { type: 13, state: 1, nIdList: [14794] } })
//配置项
let componentName = 'certificateStatisticsCfg'

const columns = [
  {
    name: 'id',
    dataIndex: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '证书分类',
    name: 'categoryId',
    dataIndex: 'categoryId',
    searchItem: {
      ...categoryConfig,
      diy: WizTableForm,
      selectType: 'radio',
    },
  },
  {
    title: '品牌',
    name: 'brandId',
    dataIndex: 'brandId',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio'
    }
  },
  {
    title: '统计内容名称',
    name: 'name',
    dataIndex: 'name',
    tableItem: {
      width: 150
    }
  },
  {
    title: '证书分类',
    name: 'categoryName',
    dataIndex: 'categoryName',
    tableItem: {
      width: 150
    }
  },
  {
    title: '证书级别',
    name: 'certNames',
    dataIndex: 'certNames',
    tableItem: {}
  },
  {
    title: '品牌',
    name: 'brandName',
    dataIndex: 'brandName',
    tableItem: {
      width: 150
    }
  },
  {
    title: '状态',
    name: 'state',
    dataIndex: 'state',
    searchItem: {
      type: 'select'
    },
    tableItem: {
      type: 'select',
      width: 100
    },
    dict: [
      { code: 0, codeName: '无效' },
      { code: 1, codeName: '有效' }
    ],
  },
]

const templateConfig = (self) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns,
        searchBarProps: {
          buttonSort: ['add'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '创建', type: 'primary' },
              customOnClick: {
                key: 'modal',
                params: {
                  modalKey: 'addModal',
                  modalParams: {
                    title: '新增',
                    style: { minWidth: 700 },
                    diy: (e) => {
                      let addProps = {
                        key: self.state.addTimestamp,
                        ref: r => ref = r && r.getWrappedInstance(),
                        editorSuccess: () => {
                          self.setState({ addTimestamp: new Date().getTime() })
                          self.doAction(apis.list)
                        },
                        ...e
                      }
                      return <AddConfig {...addProps} />
                    },
                    onOk: () => {
                      ref._ok()
                    },
                    onCancel: () => {
                      self.setState({ addTimestamp: new Date().getTime() })
                    },
                    width: 600
                  },
                }
              }
            }
          ],
          collapse: false,
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['enableOrDisable', 'delete'],
        rowOperateView: [
          {
            key: 'enableOrDisable',
            custom: true,
            params: { children: '启用' },
            textFormat: {
              recordKey: 'state',
              dirt: { 0: '启用', 1: '禁用' }
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'enable',
                apiParams: {

                }
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${record['state'] === 0 ? '启用' : '禁用'}该配置吗？`
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      ...record,
                      state: record['state'] == 1 ? '0' : '1'
                    })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            }
          },
          {
            key: 'delete',
            custom: true,
            params: { children: '删除' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'delete',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                WizModal.confirm({
                  title: '您确定要删除该配置吗？',
                  onOk: () => {
                    callback && callback({
                      idList: [record['id']]
                    })
                  },
                  onCancel() {
                  }
                })
                return null
              }
            },
          }
        ]
      }
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
